"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_FIELDS = void 0;
exports.resolveRetailLinkPrice = resolveRetailLinkPrice;
exports.resolveChannelConfig = resolveChannelConfig;
exports.emptyChannelClear = emptyChannelClear;
const ALL = ['retail', 'online', 'b2b'];
exports.CHANNEL_FIELDS = [
    { key: 'enabled', label: 'Available', kind: 'bool', channels: ALL, linkable: false, requiredToGoLive: true },
    { key: 'price', label: 'Price', kind: 'price', channels: ALL, linkable: true, requiredToGoLive: true, wizardStep: 'price' },
    { key: 'taxIds', label: 'Taxes', kind: 'multi', channels: ALL, linkable: true, requiredToGoLive: false, optionsSource: 'taxes', wizardStep: 'tax' },
    { key: 'feeIds', label: 'Fees', kind: 'multi', channels: ALL, linkable: true, requiredToGoLive: false, optionsSource: 'fees', wizardStep: 'tax' },
    { key: 'cashDiscountId', label: 'Cash price', kind: 'single', channels: ['retail', 'online'], linkable: true, requiredToGoLive: false, optionsSource: 'cashDiscounts', gate: 'cashOnDelivery', wizardStep: 'cash' },
    { key: 'promotionId', label: 'Promotion', kind: 'single', channels: ALL, linkable: true, requiredToGoLive: false, optionsSource: 'promotions', wizardStep: 'promo' },
    { key: 'commissionId', label: 'Commission', kind: 'single', channels: ALL, linkable: true, requiredToGoLive: false, optionsSource: 'commissions', wizardStep: 'promo' },
    { key: 'compliancePresetId', label: 'Compliance', kind: 'single', channels: ALL, linkable: true, requiredToGoLive: false, optionsSource: 'compliancePresets', onlineLock: 'retail', wizardStep: 'compliance' },
];
const round2 = (n) => Math.round(n * 100) / 100;
/**
 * Effective linked price from the Retail price. Same math and rounding as
 * bulk-operations-service utils/priceMath.ts (retail_* modes): round to cents,
 * never below 0. Retail ≤ 0 (or missing) → 0.
 */
function resolveRetailLinkPrice(retailPrice, link) {
    const retail = typeof retailPrice === 'number' && isFinite(retailPrice) ? retailPrice : 0;
    if (retail <= 0)
        return 0;
    const v = typeof link.value === 'number' && isFinite(link.value) ? link.value : 0;
    let after;
    switch (link.mode) {
        case 'plus_amount':
            after = retail + v;
            break;
        case 'minus_amount':
            after = retail - v;
            break;
        case 'plus_percent':
            after = retail * (1 + v / 100);
            break;
        case 'minus_percent':
            after = retail * (1 - v / 100);
            break;
        case 'match':
        default: after = retail;
    }
    return round2(Math.max(0, after));
}
/**
 * The effective config for one channel of a VariantLocation: a linked price and
 * linked fields are replaced from `vl.retail`. Returns the stored config itself
 * (same reference) when it has no link, and always for `retail`.
 */
function resolveChannelConfig(vl, channel) {
    const cfg = vl[channel];
    if (!cfg || channel === 'retail')
        return cfg;
    const link = cfg.retailLink;
    if (!link)
        return cfg;
    const retail = vl.retail ?? {};
    const out = { ...cfg };
    if (link.price)
        out.price = resolveRetailLinkPrice(retail.price, link.price);
    for (const field of (link.fields ?? [])) {
        const def = exports.CHANNEL_FIELDS.find(f => f.key === field);
        if (!def || !def.linkable || !def.channels.includes(channel))
            continue;
        const v = retail[field];
        out[field] = Array.isArray(v) ? [...v] : (def.kind === 'multi' ? [] : v);
    }
    return out;
}
function emptyChannelClear() {
    return {
        enabled: false,
        price: 0,
        taxIds: [],
        feeIds: [],
        cashDiscountId: null,
        promotionId: null,
        commissionId: null,
        compliancePresetId: null,
        retailLink: null,
    };
}
//# sourceMappingURL=channelFields.js.map